import {format} from 'date-fns';
import React from 'react';

import {ForecastQueryRenderer} from '../../../../../../../ForecastQueryRenderer';
import TimeRegistrationModalTimeOnDay, {
	TimeRegistrationModalTimeOnDayPlaceholder,
	TimeRegistrationModalTimeOnDayQuery,
} from '../modal-content/TimeRegistrationModalTimeOnDay';

import type {RelayProps} from '../../../../../../../relay-helpers/TSRelayConverter';
import type {TimeRegistrationModalTimeOnDay_viewer} from '../modal-content/__generated__/TimeRegistrationModalTimeOnDay_viewer.graphql';

type TimeRegistrationModalTimeOnDayQueryWrapperProps = {
	personId: string;
	date: Date;
};

function TimeRegistrationModalTimeOnDayQueryWrapper({
	personId,
	date,
}: TimeRegistrationModalTimeOnDayQueryWrapperProps): JSX.Element {
	return (
		<ForecastQueryRenderer
			key="query-render-time_reg_modal_timer"
			query={TimeRegistrationModalTimeOnDayQuery}
			variables={{personId, date: format(date, 'yyyy-MM-dd')}}
			showLoader={true}
			customLoader={() => <TimeRegistrationModalTimeOnDayPlaceholder />}
			render={(relayProps: RelayProps<TimeRegistrationModalTimeOnDay_viewer>) => {
				return <TimeRegistrationModalTimeOnDay {...relayProps} date={date} />;
			}}
		/>
	);
}

export default TimeRegistrationModalTimeOnDayQueryWrapper;
